import { FormGroup, List, Popover } from "@material-ui/core";
import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Row, Col } from "reactstrap";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import Popper from "@material-ui/core/Popper";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Fade from "@material-ui/core/Fade";
import Paper from "@material-ui/core/Paper";
import Select from "react-select";
import { selectorStyle } from "../../../meetingEditor/layout/other/EventSelector";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  paper: {
    overflow: "visible",
    background: "transparent",
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export const EventLayoutList = (props) => {
  const classes = useStyles();

  const { activeEventLayouts, activateLayout, events, layouts } = props;

  return (
    <div style={{ padding: "0px 15px" }}>
      <Row>
        <Col>
          <Typography className={classes.typography + " primary-text bold"}>
            <SystemLabel name="Event" />
          </Typography>
        </Col>
        <Col>
          <Typography className={classes.typography + " primary-text bold"}>
            <SystemLabel name="ActiveLayout" />
          </Typography>
        </Col>
      </Row>
      <List className="dark-scroll" style={{ maxHeight: "calc(100vh - 134px)", minHeight: "calc(100vh - 134px)", overflowY: "auto", overflowX: "hidden" }}>
        {events.map((a, i) => {
          let activeLayout = activeEventLayouts.find((ae) => ae.eventId == a.eventId);
          let evId = a.eventId;
          return (
            <Row key={a.name + i} style={{ marginBottom: 5 }}>
              <Col>
                <Typography className={classes.typography + " primary-text"}>{a.name}</Typography>
              </Col>
              <Col>
                <LayoutPop {...props} activeLayout={activeLayout} eventId={evId} />
              </Col>
            </Row>
          );
        })}
      </List>
    </div>
  );
};

const LayoutPop = ({ layouts, activeLayout, activateLayout, eventId }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [activationProps, setActivationProps] = useState(null);
  const [selectedLayout, setSelectedLayout] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(null);
    setSelectedLayout(null);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <>
      <Button
        aria-describedby={id}
        className={activeLayout ? "primary-dark-btn" : "secondary-dark-btn"}
        onClick={(e) => {
          handleClick(e);
          setSelectedLayout(activeLayout ? { value: activeLayout.layoutId, label: layouts.find((l) => l.meetingLayoutId == activeLayout.layoutId)?.name } : null);
        }}
      >
        {activeLayout ? layouts.find((l) => l.meetingLayoutId == activeLayout.layoutId)?.name : <SystemLabel name="NoneActive" />}
      </Button>
      <Popover
        id={id}
        classes={classes}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Paper className="dark-l3 primary-text" style={{ padding: 15, width: 300 }}>
          <Typography className={classes.typography} style={{ marginBottom: "0.5rem" }}>
            <SystemLabel name="SelectALayout" />
          </Typography>
          <Select
            className="jirango-select"
            options={
              layouts
                ? layouts.map((t) => {
                    return { value: t.meetingLayoutId, label: t.name };
                  })
                : []
            }
            value={selectedLayout}
            onChange={(opt) => {
              setActivationProps({ layoutId: opt.value, eventId });
              setSelectedLayout(opt);
            }}
            styles={selectorStyle}
          />
          <div style={{ display: "flex", flexDirection: "row-reverse", width: "100%", marginTop: 10 }}>
            <Button
              startIcon={<PlayArrowIcon />}
              className="primary-dark-btn"
              disabled={!activationProps}
              onClick={() => {
                activateLayout(activationProps.eventId, activationProps.layoutId);
                setActivationProps(null);
                setSelectedLayout(null);
                setAnchorEl(null);
              }}
            >
              <SystemLabel name="Activate" />
            </Button>
            <Button
              style={{ marginRight: 5 }}
              className="primary-text"
              onClick={() => {
                setActivationProps(null);
                setSelectedLayout(null);
                setAnchorEl(null);
              }}
            >
              <SystemLabel name="Cancel" />
            </Button>
          </div>
        </Paper>
      </Popover>
    </>
  );
};
